import React from "react";
import { ConsentStaticTexts } from "./CookieConsentModal";

interface InitialViewProps {
    onExpand: () => void;
    texts: ConsentStaticTexts;
    onAcceptAll: () => void;
    onAcceptEssential: () => void;
}

export const InitialView: React.FC<InitialViewProps> = ({
    onExpand,
    texts,
    onAcceptAll,
    onAcceptEssential
}) => {
    return (
        <div className="tq-modal un-ds-modal tq-modal-visible un-ds-modal-generic un-modal-cookies">
            <div className="tq-modal-overlay" role="dialog" aria-modal="true"></div>
            <div className="tq-modal-container tq-modal-l">
                <div className="tq-modal-header">
                    <p className="tq-main-color un-ds-heading-3 tq-text-center">
                        {texts["main-title"]}
                    </p>
                    <button
                        type="button"
                        name="button"
                        className="tq-hyperlink un-ds-hyperlink tq-text-center tq-main-color"
                        onClick={onAcceptEssential}
                    >
                        {texts["accept-essential-button"]}
                    </button>
                </div>
                <div className="tq-modal-scroll">
                    <div className="tq-modal-content">
                        <p>{texts["main-description"]}</p>
                    </div>
                </div>
                <div className="tq-modal-footer un-ds-action-section-center">
                    <button
                        className="tq-button un-ds-button un-ds-button-outline un-ds-component-sm"
                        onClick={onExpand}
                    >
                        <span className="tq-text-node">{texts["personalize-button"]}</span>
                    </button>
                    <button
                        className="tq-button un-ds-button un-ds-button-solid un-ds-component-sm"
                        onClick={onAcceptAll}
                    >
                        <span className="tq-text-node">{texts["accept-all-button"]}</span>
                    </button>
                    <div className="tq-modal-footer-link">
                        <p dangerouslySetInnerHTML={{ __html: texts["reference-link"] }}></p>
                    </div>
                </div>
            </div>
        </div>
    );
};
